"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _hamburger = require("./shapes/hamburger");

var _colors = require("./colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.show && !this.props.show) {
        document.body.className = document.body.className.replace(/ ?modal-open/, '');
      } else if (this.props.show && !prevProps.show) {
        document.body.className += document.body.className.length ? ' modal-open' : 'modal-open';
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // clean up any open modal classes from the body before unmounting the component
      document.body.className = document.body.className.replace(/ ?modal-open/, '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          title = _this$props.title,
          closeButton = _this$props.closeButton,
          footer = _this$props.footer,
          bsSize = _this$props.bsSize,
          onRequestHide = _this$props.onRequestHide,
          closeOnOutsideClick = _this$props.closeOnOutsideClick,
          style = _this$props.style,
          className = _this$props.className,
          bsStyle = _this$props.bsStyle,
          wrapperStyle = _this$props.wrapperStyle;
      var modalClassName = 'modal-dialog';

      if (bsSize) {
        modalClassName += " modal-".concat(bsSize);
      }

      if (className) {
        modalClassName += ' ' + className;
      }

      var modalBodyClassName = 'modal-content';

      if (bsStyle) {
        modalBodyClassName += " modal-".concat(bsStyle);
      }

      var ModalHeader = _react["default"].createElement("div", {
        className: "modal-header"
      }, _react["default"].createElement("div", {
        className: "modal-title"
      }, title), closeButton ? _react["default"].createElement("button", {
        className: "close",
        onClick: onRequestHide
      }, _react["default"].createElement(_hamburger.Close, {
        width: "16px",
        color: _colors.granite.base,
        cropped: true
      })) : null);

      var ModalFooter = footer && _react["default"].createElement("div", {
        className: "modal-footer"
      }, footer);

      var modalNode = _react["default"].createElement("div", {
        className: "modal fade ".concat(show ? 'in' : ''),
        style: _objectSpread({
          visibility: show ? 'visible' : 'hidden',
          display: 'block',
          paddingLeft: '0px'
        }, wrapperStyle),
        tabIndex: "-1"
      }, _react["default"].createElement("div", {
        className: modalClassName,
        style: _objectSpread({
          zIndex: '1050'
        }, style)
      }, _react["default"].createElement("div", {
        className: modalBodyClassName
      }, ModalHeader, _react["default"].createElement("div", {
        className: "modal-body"
      }, this.props.children), ModalFooter)), _react["default"].createElement("div", {
        className: "modal-backdrop fade ".concat(show ? 'in' : ''),
        onClick: closeOnOutsideClick ? onRequestHide : null
      }));

      return _reactDom["default"].createPortal(modalNode, document.body);
    }
  }]);

  return Modal;
}(_react["default"].Component);

exports["default"] = Modal;
Modal.defaultProps = {
  closeOnOutsideClick: false
};
Modal.propTypes = {
  title: _propTypes["default"].node,
  className: _propTypes["default"].string,
  style: _reactStyleProptype["default"],
  wrapperStyle: _reactStyleProptype["default"],
  footer: _propTypes["default"].node,
  show: _propTypes["default"].bool.isRequired,
  onRequestHide: _propTypes["default"].func,
  closeOnOutsideClick: _propTypes["default"].bool,
  closeButton: _propTypes["default"].bool,
  bsSize: _propTypes["default"].oneOf(['sm', 'lg']),
  bsStyle: _propTypes["default"].oneOf(['warning', 'error', 'danger', 'success', 'info']),
  children: _propTypes["default"].node
};